import { render } from "./BadLanguages.vue?vue&type=template&id=d6ae282e&scoped=true"
import script from "./BadLanguages.vue?vue&type=script&lang=js"
export * from "./BadLanguages.vue?vue&type=script&lang=js"

import "./BadLanguages.vue?vue&type=style&index=0&id=d6ae282e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6ae282e"]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QInput,QBtn});
